import ObjectBuilderInterface from "@/modules/api/object-builder.interface";
import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import ApiService from "@/modules/api/api.service";
import BasicRepository from "@/modules/api/basic.repository";
import { DirectoryValue } from "@/modules/api/directory-value.model";
import { Dictionary } from "@/lib/Dictionary.type";

export default class TagRepository extends BasicRepository<DirectoryValue> {
  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<DirectoryValue>,
    responseParser: ApiCollectionResponseParserService<DirectoryValue>
  ) {
    super("tags", api, objectBuilder, responseParser);
  }

  public async searchTags(term: string, limit = 10): Promise<DirectoryValue[]> {
    const data: Dictionary<string | number | boolean> = {
      term,
      limit,
    };

    const response = await this.api.post("tags/autocomplete-requests", data);

    const collection = this.responseParser.parse(
      response.data,
      this.objectBuilder
    );

    return collection.getItems();
  }
}
